var App = App || {};

App.ResourcesBand = (function ($) {
    "use strict";

    function init() {

        resizeBackgrounds();

        $(window).on("resize", function () {
            resizeBackgrounds();
        });
    }

    function resizeBackgrounds() {
        $(".block.block-resources-band").each(function () {
            var tipHeight = $(this).find(".resources-band-upper").outerHeight();
            var backgroundEl = $(this).find(".resources-band-upper .background");
            backgroundEl.css("height", tipHeight);
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ResourcesBand.init();
});